import { useSingleSchema } from "../../toolympus/hooks/useSchema";
import { useSmartList } from "../../toolympus/hooks/useSmartList"

export interface GanttRecord {
  _id: number;
  title: string;
  data: any; // Or a more specific type if the JSON structure is known, e.g., Record<string, any> or GanttData
  created_at: string; // Typically an ISO 8601 string in TS
  created_by: string; // UUID of the user who created it
  updated_at?: string; // Optional datetime string
  updated_by?: string; // Optional UUID of the user who updated it
  tasks_count?: number;
}

export const GanttApiPath = `/api/gantt/plan`;

export const useGanttsList = () => {
  const schema = useSingleSchema(`${GanttApiPath}/uiconfig`);
  const data = useSmartList<GanttRecord>(GanttApiPath, {
    newRecordDefault: { title: "", data: { tasks: [], rows: [], dependencies: [] } } as any,
    schema: schema.schema,
  });

  return data;
}
